// RO locale formatters

const eurFmt = new Intl.NumberFormat('ro-MD', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const numFmt = new Intl.NumberFormat('ro-MD', { maximumFractionDigits: 0 });

export const eur = (v) => eurFmt.format(v);
export const num = (v) => numFmt.format(v);
export const km  = (v) => `${numFmt.format(v)} km`;

// Simple amortization for finance calc
// monthly = P * r / (1 - (1+r)^-n) where r = APR/12, n = months
export function monthlyPayment(principal, apr, months) {
  if (principal <= 0 || months <= 0) return 0;
  if (apr <= 0) return principal / months;
  const r = apr / 12;
  return (principal * r) / (1 - Math.pow(1 + r, -months));
}
